// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1W_kL","buttons":"SendReceipts_buttons__3yaUv","email":"SendReceipts_email__1J5fw","bookApptTitle":"SendReceipts_bookApptTitle__wpTrh"};